import {
  Button,
  FormControl,
  Input,
  InputAdornment,
  InputLabel,
  styled,
} from "@mui/material";
import React, { Suspense, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from "recharts";
import "./CreditsUsageDashboard.css";
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { stripePromise } from "../../../../../../utils/informationUtility";
import {
  AccountCircle,
  AttachMoney,
  Money,
  Padding,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import axios from "axios";

const CreditUsageDashboard = ({ usedCredits, totalCredits }) => {
  const { organization } = useSelector((state) => state.organization);
  const [options, setOptions] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showCreditInput, setShowCreditInput] = useState(false);
  const [inputCredtis, setInputCredits] = useState("");
  const data = [
    { name: "Used", value: usedCredits },
    { name: "Remaining", value: totalCredits - usedCredits },
  ];

  const COLORS = ["#0088FE", "#00C49F"];

  const LightFormControl = styled(FormControl)({
    "& .MuiInputLabel-root": {
      color: "rgba(255, 255, 255, 0.7)",
      Padding: "4px 1px",
    },
    "& .MuiInput-root": {
      color: "white",
      "&:before": {
        borderBottomColor: "rgba(255, 255, 255, 0.42)",
      },
      "&:hover:not(.Mui-disabled):before": {
        borderBottomColor: "rgba(255, 255, 255, 0.87)",
      },
      "&.Mui-focused:after": {
        borderBottomColor: "#90caf9",
      },
    },
    "& .MuiInputAdornment-root": {
      color: "rgba(255, 255, 255, 0.7)",
    },
  });

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(value);
  };

  const handlePurchaseCredits = async () => {
    setLoading(true);
    const token = localStorage.getItem("token").replaceAll(`"`, "");

    const org_id = organization?._id["$oid"];
    try {
      const response = await axios.post(
        `/api/payments/subscribe/credit/${inputCredtis}`,
        { org_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Include JWT for authentication
          },
        }
      );

      if (response.data) {
        window.open(response.data);
      } else {
        setErrorMessage(
          "Error: Failed to initiate payment. Please contact support for assistance."
        );
      }
    } catch (error) {
      setErrorMessage(
        "Error: Failed to initiate payment. Please contact support for assistance."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-container">
      {/* <div className="chart-container"> */}
      {/* <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={data}
                                cx="50%"
                                cy="50%"
                                innerRadius={60}
                                outerRadius={80}
                                fill="#8884d8"
                                dataKey="value"
                                label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
                            >
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer> */}
      {/* </div> */}
      <div className="info-container">
        {/* <div className="credit-info">
                        <p className="info-value-used">{formatCurrency(usedCredits)}</p>
                        <p className="info-value-total">/ {formatCurrency(totalCredits) < 0 ? 0 : formatCurrency(totalCredits)}</p>
                    </div> */}

        {showCreditInput && (
          <LightFormControl variant="outlined">
            <InputLabel htmlFor="input-with-icon-adornment">
              Input Credits (USD)
            </InputLabel>
            <Input
              autoFocus
              id="input-with-icon-adornment"
              startAdornment={
                <InputAdornment position="start">
                  <AttachMoney />
                </InputAdornment>
              }
              value={inputCredtis}
              onChange={(e) => setInputCredits(e.target.value)}
            />
          </LightFormControl>
        )}

        <button
          className="purchase-button"
          onClick={
            showCreditInput
              ? handlePurchaseCredits
              : () => setShowCreditInput(true)
          }
        >
          Purchase More Credits
        </button>
      </div>
    </div>
  );
};

export default CreditUsageDashboard;
